export default "__VITE_ASSET__BYUIbrtu__"